module.exports = __webpack_public_path__ + "static/media/RaceBackgroundImage.df8394d3.png";